import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { articles } from '@/mocks/articles';
import SeoHead from '@/components/feature/SeoHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.diariode1trader.com';

const artigosSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'Blog',
    '@id': `${siteUrl}/artigos#blog`,
    name: 'Artigos de Trading | Diário de 1 Trader',
    description: 'Artigos educacionais sobre psicologia de trading, gestão de risco, sessões de mercado e estratégias para traders de futuros.',
    url: `${siteUrl}/artigos`,
    inLanguage: 'pt-PT',
    publisher: {
      '@type': 'Organization',
      name: 'Diário de 1 Trader',
      url: siteUrl,
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Início', item: `${siteUrl}/` },
      { '@type': 'ListItem', position: 2, name: 'Artigos', item: `${siteUrl}/artigos` },
    ],
  },
];

export default function ArtigosPage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="Artigos de Trading | Psicologia, Gestão de Risco e Estratégias"
        description="Artigos gratuitos sobre trading de futuros: psicologia, gestão de risco, sessões de mercado, prop firms e estratégias. Conteúdo educacional para todos os níveis."
        keywords="artigos trading, psicologia trading, gestão risco, sessões mercado, futuros"
        canonical="/artigos"
        schema={artigosSchema}
      />
      <Navbar />
      <div className="pt-28 pb-20 max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 text-xs font-semibold px-4 py-2 rounded-full mb-4">
            <i className="ri-article-line"></i>
            Conteúdo Educacional
          </div>
          <h1 className="text-3xl md:text-5xl font-extrabold text-[#0d1f3c] mb-4">Artigos Gerais de Trading</h1>
          <p className="text-slate-500 max-w-2xl mx-auto">Psicologia, gestão de risco, sessões de trading e muito mais. Conteúdo gratuito para traders de todos os níveis.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((article) => (
            <Link key={article.id} to={`/artigos/${article.id}`} className="group bg-white rounded-2xl overflow-hidden border border-blue-100 hover:border-blue-300 transition-all cursor-pointer">
              <div className="h-48 overflow-hidden">
                <img src={article.image} alt={article.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-3">
                  <span className="flex items-center gap-1.5 bg-blue-50 text-blue-700 text-xs font-semibold px-3 py-1 rounded-full">
                    <i className={`${article.categoryIcon} text-xs`}></i>{article.category}
                  </span>
                  <span className="text-slate-400 text-xs">{article.readTime} de leitura</span>
                </div>
                <h3 className="font-bold text-[#0d1f3c] text-base leading-snug mb-2 group-hover:text-blue-600 transition-colors">{article.title}</h3>
                <p className="text-slate-500 text-sm leading-relaxed line-clamp-2 mb-4">{article.excerpt}</p>
                <div className="flex items-center gap-2 pt-4 border-t border-slate-100">
                  <div className="w-7 h-7 rounded-full bg-blue-100 flex items-center justify-center">
                    <i className="ri-user-line text-blue-600 text-xs"></i>
                  </div>
                  <div>
                    <div className="text-xs font-semibold text-slate-700">{article.author}</div>
                    <div className="text-xs text-slate-400">{article.date}</div>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
